import { SORT_ORDER } from '@customTypes/Common';
import { DateTime } from 'luxon';

const _inverter = (comparator: any) => (a: any, b: any) => {
  return comparator(b, a);
};

export const sortStrings = (data: any[], key: string, order: SORT_ORDER) => {
  const comparator = (a: any, b: any) => {
    if (!a[key]) return -1;
    if (!b[key]) return 1;
    if (!a[key] && !b[key]) return 0;
    return a[key].localeCompare(b[key]);
  };
  if (order === SORT_ORDER.ASC) {
    return [...data.sort(comparator)];
  } else {
    return [...data.sort(_inverter(comparator))];
  }
};

export const sortNumbers = (data: any[], key: string, order: SORT_ORDER) => {
  const comparator = (a: any, b: any) => {
    if (isNaN(a[key])) return -1;
    if (isNaN(b[key])) return 1;
    if (isNaN(a[key]) && isNaN(b[key])) return 0;
    return a[key] - b[key];
  };
  if (order === SORT_ORDER.ASC) {
    return [...data.sort(comparator)];
  } else {
    return [...data.sort(_inverter(comparator))];
  }
};

export const sortDates = (data: any[], key: string, order: SORT_ORDER) => {
  const comparator = (a: any, b: any) => {
    const date1 = DateTime.fromISO(a[key].split('Z')[0]);
    const date2 = DateTime.fromISO(b[key].split('Z')[0]);
    if (!date1.isValid) return -1;
    if (!date2.isValid) return 1;
    return date1.startOf('day') <= date2.startOf('day') ? -1 : 1;
  };
  if (order === SORT_ORDER.ASC) {
    return [...data.sort(comparator)];
  } else {
    return [...data.sort(_inverter(comparator))];
  }
};
